<template>
  <!-- Page-owned "webreinvent" section: same markup as the layout's
       #mask-section, but rendered inside the page so it sits on the
       page's own background. The layout's copy is hidden on that page
       via the page's html.<page>-page rule in the page file.
       max-lg:-mx-4 cancels the page main's px-4 so the text keeps the
       same inset as the layout's section. -->
  <section
    class="grid place-items-center z-10 relative pt-16 lg:pt-32 max-md:px-4 max-lg:-mx-4 overflow-hidden"
  >
    <WrAnimatedImg />
  </section>
</template>

<script setup lang="ts">
const WrAnimatedImg = defineAsyncComponent(
  () => import("~/components/molecules/WrAnimatedImg.vue")
);
</script>
